import z from 'zod';

export type DoubleRange = {
	minimum: number | null;
	maximum: number | null;
};

export const DoubleRangeSchema: z.ZodType<DoubleRange> = z.object({
	minimum: z.number().nullable(),
	maximum: z.number().nullable(),
});
